﻿import controller from '../../../../resources/scripts/_shared/controller';

function facilityUSPBlock(context) {

  function init() {

    const uspButtons = document.querySelectorAll(".facilityuspblock__heading");
    const uspDetailsBlocks = document.querySelectorAll(".facilityuspblock__details");
    const closeXs = document.querySelectorAll(".facilityuspblock__details__close");

    uspDetailsBlocks.forEach((block, n) => {
      const id = 'details' + n
      block.setAttribute('id', id)
      block.closest('.facilityuspblock').querySelector('.facilityuspblock__heading').setAttribute('aria-controls', id);
     })

    const showDetails = (event) => {
      event.stopPropagation()
      const targetParent = event.target.closest('.facilityuspblock')
      const target = targetParent.querySelector('.facilityuspblock__details')
      const id = +target.id.substring(7)
      const y = uspButtons[id].getBoundingClientRect().top - event.target.closest('.facilityuspblock').parentElement.getBoundingClientRect().top + 46;

      targetParent.classList.toggle("facilityuspblock--opendetails");
      target.style.top = y + "px";

      if (targetParent.classList.contains("facilityuspblock--opendetails")) {
        targetParent.querySelector('.facilityuspblock__heading').setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
      } else {
        targetParent.querySelector('.facilityuspblock__heading').setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
      }
      closeDetails(id);
    }

    const closeDetails = (n) => {
      uspDetailsBlocks.forEach(block => {
        const id = +block.id.substring(7);
        const blockParent = block.closest('.facilityuspblock');
        if (id === n || !blockParent.classList.contains("facilityuspblock--opendetails")) return
        block.setAttribute('aria-hidden', 'true');
        blockParent.querySelector('.facilityuspblock__heading').setAttribute('aria-expanded', 'false');
        blockParent.classList.remove("facilityuspblock--opendetails");
      })
    }

    const stopPropagation = () => event.stopPropagation()

    uspButtons.forEach(button => button.addEventListener('click', showDetails))
    uspDetailsBlocks.forEach(block => block.addEventListener('click', stopPropagation))
    closeXs.forEach(closeX => closeX.addEventListener('click', closeDetails))

    document.body.onclick = () => closeDetails()
    window.onresize = () => closeDetails()

  }

  return {
    init
  };
}

controller.add('facility-usp-block', facilityUSPBlock);